/* Arkhades — onglet qui rappelle le visiteur parti voir ailleurs.
   Le titre alterne entre deux messages et le favicon reçoit une pastille, uniquement quand l'onglet est
   caché ; tout revient à l'identique au retour. Aucune donnée collectée, aucun cookie. */
(function () {
  var M1 = "👋 Don't leave just yet…", M2 = "Your selection is waiting", DELAI = 2000;
  var titreOrigine = document.title, minuteur = null, alterne = false;
  var lien = document.querySelector('link[rel~="icon"]');
  var faviconOrigine = lien ? lien.getAttribute("href") : null;
  var faviconAlerte = null;

  function preparerFavicon() {
    if (!lien || !faviconOrigine || faviconAlerte) return;
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      try {
        var c = document.createElement("canvas");
        c.width = 64; c.height = 64;
        var x = c.getContext("2d");
        x.drawImage(img, 0, 0, 64, 64);
        x.beginPath(); x.arc(48, 16, 15, 0, Math.PI * 2);
        x.fillStyle = "#e11d48"; x.fill();
        x.strokeStyle = "#ffffff"; x.lineWidth = 4; x.stroke();
        faviconAlerte = c.toDataURL("image/png");
      } catch (e) { /* image d'un autre domaine : on garde le titre seul */ }
    };
    img.src = faviconOrigine;
  }
  function poserFavicon(href) { if (lien && href) lien.setAttribute("href", href); }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      preparerFavicon();
      if (minuteur) return;
      minuteur = setInterval(function () {
        alterne = !alterne;
        document.title = alterne ? M1 : M2;
        poserFavicon(alterne ? (faviconAlerte || faviconOrigine) : faviconOrigine);
      }, DELAI);
      document.title = M1;
      alterne = true;
    } else {
      if (minuteur) { clearInterval(minuteur); minuteur = null; }
      document.title = titreOrigine;
      poserFavicon(faviconOrigine);
    }
  });
})();